import { View } from 'react-native';
import Amount from 'design-system/Amount';
import { format } from 'date-fns';
import React, { memo } from 'react';
import { CardView, rem } from 'design-system';
import { IconBoldCalendar } from 'design-system/icons';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import Text from 'design-system/Text';
import IconCircle from 'design-system/icons/IconCircle';
import ToolTip from 'design-system/ToolTip';
import { getDailyAllowance } from '../utils/getDailyAllowance';
const strings = {
    title: 'Daily allowance',
    toolTipTitle: 'What’s your daily allowance?',
    toolTipSubtitle: [
        'It’s how much you can spend each day until the end of your period and still stay within budget.',
        'We take your total budget, subtract what you’ve spent and your committed spending, then divide what’s left by the days left in the period. If you’re over budget, it shows zero.',
    ],
};
export const DailyAllowanceView = memo(({ isCurrentPeriod, currentMonthlyTotal }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    if (!isCurrentPeriod || !currentMonthlyTotal) {
        return null;
    }
    const dailyAllowance = getDailyAllowance(currentMonthlyTotal);
    if (dailyAllowance == null) {
        return null;
    }
    return (<CardView noMarginTop>
        <View style={styles.container}>
          <View style={styles.content}>
            <IconCircle width={44} height={44} color={colors.background.dark}>
              <IconBoldCalendar />
            </IconCircle>
            <View style={styles.innerContent}>
              <View style={styles.titleContainer}>
                <View style={styles.titleRow}>
                  <Text Text-16>{strings.title}</Text>
                  <ToolTip colorKey="secondary" title={strings.toolTipTitle} subtitle={strings.toolTipSubtitle} small/>
                </View>
                <Text Secondary TextThin-14>{`Until ${format(new Date(currentMonthlyTotal.to), 'dd MMM')}`}</Text>
              </View>

              <Amount Numbers-16 value={{
            value: dailyAllowance,
            currency: currentMonthlyTotal.currency,
        }}/>
            </View>
          </View>
        </View>
      </CardView>);
});
const styleSet = createStyleSheets(() => ({
    container: {
        padding: rem(16),
        justifyContent: 'center',
    },
    content: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    innerContent: {
        flex: 1,
        flexDirection: 'row',
        marginStart: rem(16),
        alignItems: 'center',
    },
    titleRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(4),
    },
    titleContainer: {
        flex: 1,
        justifyContent: 'space-between',
    },
}));
